<template>
  <div class="container">
    <section>
      <h1>
        {{ $t('errorPages:partnerRequired.headline') }}
      </h1>
      <p>{{ $t('errorPages:partnerRequired.firstParagraph') }}</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PartnerRequired',
  i18nOptions: { namespaces: 'errorPages' },
  serverPrefetch() {
    this.$store.commit('SET_APP_HTTPSTATUS', 501);
    return Promise.resolve();
  },
};
</script>
